import React, { useState } from "react"; 
import styles from '../../css/Part11.module.css';

function ImageComponent() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [touchStartX, setTouchStartX] = useState(0);
  const [touchEndX, setTouchEndX] = useState(0);

  const peopleImages = [
    "/images/team/JpChin.png",
    "/images/team/TM.png",
    "/images/team/Kamil.png",
    "/images/team/Javen.png"
  ];

  // Handle touch start for swipe
  const handleTouchStart = (e) => {
    setTouchStartX(e.touches[0].clientX);
  };

  // Handle touch move for swipe
  const handleTouchMove = (e) => {
    setTouchEndX(e.touches[0].clientX);
  };

  // Handle touch end to determine swipe direction
  const handleTouchEnd = () => {
    if (touchStartX - touchEndX > 50) {
      nextImage(); // Swipe left
    } else if (touchEndX - touchStartX > 50) {
      prevImage(); // Swipe right
    }
  };

  const nextImage = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % peopleImages.length);
  };

  const prevImage = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + peopleImages.length) % peopleImages.length);
  };

  return (
    <section className={styles.imageWrapper} id="section_Team">
      <h2 className={styles.teamTitle}>Professional Team</h2>
      
      {/* Green background */}
      <img 
        src="/images/background/Group 72.png" 
        className={styles.fullWidthImage} 
        alt="background"
      />
      
      {/* Carousel for mobile view */}
      <div 
        className={`${styles.peopleWrapper} ${styles.carouselWrapper}`} 
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
      >
          {/* Mobile carousel image */}
          <img 
            src={peopleImages[currentIndex]} 
            alt={`Person ${currentIndex + 1}`} 
            className={styles.personImage}
          />

          {/* Dots Navigation */}
          <div className={styles.dotsWrapper}>
            {peopleImages.map((_, index) => (
              <span 
                key={index} 
                className={
                  index === currentIndex 
                    ? `${styles.dot} ${styles.activeDot} `
                    : styles.dot
                }
                onClick={() => setCurrentIndex(index)}
              />
            ))}
          </div>
      </div>

      {/* Desktop view - static images */}
      <div className={`${styles.peopleWrapper} ${styles.desktopWrapper}`}>
        <img src="/images/team/JpChin.png" alt="Person 1" className={styles.personImage} />
        <img src="/images/team/TM.png" alt="Person 2" className={styles.personImage} />
        <img src="/images/team/Kamil.png" alt="Person 3" className={styles.personImage} />
        <img src="/images/team/Javen.png" alt="Person 4" className={styles.personImage} />
      </div>
    </section>
  );
}

export default ImageComponent;
